<template>
  <Modal v-model="modal" :title="title" width="700">
    <Form ref="form" :model="form" :rules="rule" :label-width="60">
      <FormItem :label="$t('name.plugin.img')" prop="img">
        <Upload v-model="form.img" />
      </FormItem>
      <FormItem :label="$t('name.plugin.name')" prop="name">
        <Input v-model="form.name" />
      </FormItem>
      <FormItem :label="$t('name.plugin.permission')" prop="name">
        <Input v-model="form.permission" />
      </FormItem>
      <FormItem :label="$t('name.plugin.url')" prop="url">
        <Input v-model="form.url" />
      </FormItem>
      <FormItem :label="$t('name.plugin.sort')" prop="sort">
        <InputNumber v-model="form.sort" />
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="primary" :loading="loading" @click="onPost">{{ title }}</Button>
    </div>
  </Modal>
</template>
<script>
import { put } from '@/api/plugin'
import Upload from '@/main/components/upload'

export default {
  components: {
    Upload
  },
  computed: {
    title() {
      return this.form.id ? this.$t('name.update') : this.$t('name.create') 
    }
  },
  data() {
    return {
      modal: false,
      loading: false,
      form: {},
      field: {
        name: '',
        permission: '',
        img: '',
        url: '',
        sort: 0
      },
      rule: {
        name: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        permission: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        img: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        url: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        sort: [
          { required: true, type: 'number', message: ' ', trigger: 'blur' }
        ]
      },
    }
  },
  methods: {
    open(data) {
      this.modal = true

      if(!data) {
        // 初始化字段
        data = Object.assign({}, this.field)
      }
      // 深拷贝
      this.form = Object.assign({}, data)

      // 清空验证
      this.$refs.form.resetFields()
    },
    close() {
      this.modal = false
    },
    onPost() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          put(this.form).then(res => {
            this.close()
            this.loading = false
            this.$Message.success(this.$t('message.' + res.message))
            this.$emit('get')
          }).catch(res => {
            this.loading = false
            this.$Message.error(this.$t('message.error.' + res.message))
          })
        }
      })
    }
  }
}
</script>